import React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './util/i18n/i18next';
import * as serviceWorkerRegistration from './sw/serviceWorkerRegistration';
import { shouldUseServiceWorker } from './whitelabel';
import { disablePwaZoom } from './sw/util';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <React.Suspense>
      <App />
    </React.Suspense>
  </React.StrictMode>,
);

shouldUseServiceWorker
  ? serviceWorkerRegistration.register()
  : serviceWorkerRegistration.unregister();

disablePwaZoom();
